<div class="flex items-center gap-1">
  <span>{{ params.value }}</span>
  @if (params.data?.asset_recovery_id) {
    <mat-icon
      class="text-success text-sm"
      [matTooltip]="'AR report created at ' + (params.data.asset_recovery_created_at | date: 'MM/dd/yyyy, hh:mm a')"
      aria-hidden="true"
    >
      paid
    </mat-icon>
  }
</div>
